export const getSlotHistoryQueryFn = (court_id: string, date: string) => {
  const query = `
            getSlotHistory( court_id: $court_id, date: $date) {
                ... on SlotHistory {
                datetime_start
                court_id
                history {
                    created_at
                    created_by
                    event
                }
                slot_comment
                }
                ... on Error {
                code
                message
                }
            }
        `;
  const inputs = `$court_id: String!, $date: String!`;
  const variables = { court_id: court_id, date: date };
  return {
    query,
    inputs,
    variables,
  };
};

export const createSlotWarningQueryFn = (
  datetime: string,
  court_id: string,
  comment: string,
) => {
  const query = `
            createSlotWarning(datetime: $datetime, court_id: $court_id, comment: $comment) {
                ... on SummaryItem {
                    warning
                  }
                  ... on Error {
                  code
                  message
                  }
            }
        `;
  const inputs = `$datetime: String!, $court_id: String!, $comment: String!`;
  const variables = { datetime, court_id, comment };
  return {
    query,
    inputs,
    variables,
  };
};

export const createBulkSlotWarningQueryFn = (
  courts: string[],
  start_date: string,
  end_date: string,
  start_time: string,
  end_time: string,
  comment: string,
) => {
  const query = `
    createBulkSlotWarnings( courts: $courts, start_date: $start_date, end_date: $end_date, start_time: $start_time, end_time: $end_time, comment: $comment) { 
      ... on BulkSlotWarningSuccess {
        success
      }
      ... on Error {
        code
        message
      }
    } 
  `;

  const inputs = `$courts: [String!]!, $start_date: String!, $end_date: String!, $start_time: String!, $end_time: String!, $comment: String!`;

  const variables = {
    courts,
    start_date,
    end_date,
    start_time,
    end_time,
    comment,
  };

  return { query, inputs, variables };
};
